<template>
  <div class="bg_blue">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/indexpc' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/wrong-questions' }"
          >错题集</el-breadcrumb-item
        >
        <el-breadcrumb-item> 错题详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="left_and_right_container">
        <div class="container_left">
          <div class="container_left_content">
            <div class="container_left_content_img">
              <img :src="userdata.face" />
            </div>
            <div class="container_left_content_name">
              <span>会员号：</span>{{ userdata.name }}
            </div>
            <!-- <div class="container_left_content_serve">
              <i class="el-icon-service"></i>
              <a
                @click="serviceCustomerClickFun()"
                :style="{ color: '#1981ff' }"
                >联系客服</a
              >
            </div> -->
          </div>
        </div>

        <div class="container_center">
          <div class="question_title">
            <el-tag
              v-if="questionData.options && questionData.options.length == 2"
            >
              单选</el-tag
            >
            <el-tag type="success" v-else> 多选</el-tag>
            {{
              questionData.questiontitle ? questionData.questiontitle.title : ""
            }}
          </div>
          <div class="question_optoins">
            <div v-for="(option, index) in questionData.options" :key="index">
              <el-button
                style="min-width: 253px !important"
                :type="option.selected == 1 ? 'primary' : ''"
                round
                :plain="option.selected == 1 ? false : true"
                >{{ option.title }}</el-button
              >
            </div>
          </div>
          <el-alert
            style="width: 500px; margin: 50px auto 20px auto"
            title="回答错误"
            type="error"
            show-icon
          >
            答案：<span style="margin-right: 20px">{{ answers }}</span>
            <br />
            解析：{{
              questionData.questiontitle ? questionData.questiontitle.jiexi : ""
            }}
          </el-alert>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { CountDown } from "vant";

Vue.use(CountDown);

export default {
  name: "WrongQuestionDetail",
  data() {
    return {
      userdata: {},
      questionData: [],
    };
  },
  computed: {
    answers() {
      if (!this.questionData.options) {
        return "";
      }
      //单选
      var target_desc = "";
      if (this.questionData.options.length == 2) {
        if (this.questionData.options[0].selected == 1) {
          if (this.questionData.options[0].correct == 2) {
            target_desc = "错误";
          } else {
            target_desc = "正确";
          }
        } else {
          if (this.questionData.options[0].correct == 1) {
            target_desc = "正确";
          } else {
            target_desc = "错误";
          }
        }
      } else {
        this.questionData.options.some((item) => {
          if (item.correct == 1) {
            target_desc += item.title + " ";
          }
        });
      }
      return target_desc;
    },
  },
  mounted() {
    this.getUser();
    if (!this.$route.query.question_id) {
      this.$message({ type: "error", message: "参数错误" });
      return;
    }
    this.fetchQuestionDataFun(this.$route.query.question_id);
  },
  methods: {
    getUser() {
      this.$api.get(
        "/api/index/userdata",
        {},
        (res) => {
          this.userdata = res.data;
        },
        (r) => {
          // that.$message.error(r.msg);
        }
      );
    },
    fetchQuestionDataFun(question_id) {
      this.$api.get(
        "/api/examecenter/wrongQuestionDetail",
        { question_id: question_id },
        (res) => {
          this.questionData = res.data;
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>
<style scoped lang="scss">
.score {
  font-size: 38px;
  color: #ff7d18;
  text-align: center;
  em {
    font-size: 16px;
    color: #333;
  }
}
.status-1 {
  background: #559f07;
  color: #fff;
}
.status-2 {
  background: #e02020;
  color: #fff;
}
.status-0 {
  background: #f4faff;
  color: #666666;
}
.bg_blue {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  min-height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.elalert {
  margin: 0 0 40px 0;
}
.elsteps {
  margin: 0 0 25px 0;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  //   justify-content: space-between;
  .container_left {
    width: 212px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    padding: 32px 0 0 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    align-items: center;
    margin-right: 40px;
    .countdown_class {
      display: flex;
      flex-direction: row;
      align-items: center;
      .countdown_title {
        width: 55px;
        font-size: 18px;

        font-weight: 400;
        color: #666666;
        line-height: 25px;
        margin-right: 8px;
        box-sizing: border-box;
        padding-bottom: 3px;
      }
      .countdown_content {
        font-size: 20px;
        font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
        font-weight: 500;
        color: #e02020;
        line-height: 28px;
      }
    }
    .container_left_content {
      // width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      margin: 88px 0 0 0;
      overflow: hidden;
      .container_left_content_img {
        width: 108px;
        height: 108px;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 16px;
        outline: none;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .container_left_content_name {
        font-size: 14px;

        font-weight: 500;
        color: #333333;
        line-height: 20px;
        // padding-left: 65px;
        margin-bottom: 9px;
        box-sizing: border-box;
        width: 108px;
        white-space: wrap;
        span {
          color: #666666;
        }
      }
      .container_left_content_serve {
        width: 108px;
        display: flex;
        flex-direction: row;
        line-height: 17px;
        font-size: 12px;

        font-weight: 400;
        color: #0091ff;
        margin-top: 8px;
        // padding-left: 65px;
        box-sizing: border-box;
        .el-icon-service {
          margin: 0 9px 0 0;
          font-size: 17px;
        }
        &:hover {
          cursor: pointer;
          font-weight: bold;
        }
      }
    }
  }
  .container_center {
    width: 648px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    padding: 36px 0 20px 0;
    box-sizing: border-box;
    overflow: hidden;
    .question_title {
      font-size: 18px;

      font-weight: 400;
      color: #666666;
      margin-left: 25px;
      /deep/.el-tag {
        margin-right: 8px;
        font-size: 18px;
        font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
        font-weight: 500;
        color: #333333;
      }
    }
    .question_optoins {
      margin: 14px 0 0 112px;
      /deep/.el-button {
        min-width: 253px;
        height: 41px;
        margin-bottom: 8px;
      }
    }
    .submitBtn {
      text-align: center;
      margin-top: 132px;
      /deep/.el-button {
        width: 139px;
        height: 44px;
        border-radius: 22px;
      }
    }
  }

  .container_right {
    width: 312px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 24px 32px 0 32px;
    .container_right_title {
      width: 122px;
      height: 33px;
      font-size: 24px;

      font-weight: 400;
      color: #333333;
      line-height: 33px;
    }
    .container_right_content {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      div {
        display: inline-block;
        flex: 20%;
        span {
          display: inline-block;
          width: 40px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-radius: 20px;
          margin: 16px 0 0 0;
          flex: 20px;
          &:hover {
            cursor: default;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// WrongQuestionDetail.vue?78b7eb7a